import { useEffect } from "react";

import useUiStore from "@app/analytics/stores/useUiStore";
import Tracker from "@app/utils/tracking/Tracker";

const createMetaEventTitle = (title: string): HTMLMetaElement => {
  const el = document.createElement("meta");
  el.setAttribute("name", "mptitle");
  el.content = title;
  return el;
};

const getMetaTitle = () =>
  document.querySelector("meta[name=mptitle]") as HTMLMetaElement | null;

const usePageTitle = (title: string, mobileNavTitle?: string) => {
  const setPageTitle = useUiStore((state) => state.setPageTitle);

  useEffect(() => {
    const documentTitle = `Read - ${title}`;
    document.title = documentTitle;
    setPageTitle(mobileNavTitle ?? title);

    const existingMetaTag = getMetaTitle();
    if (existingMetaTag) {
      existingMetaTag.content = documentTitle;
    } else {
      (document.head ?? document.querySelector("head")).appendChild(
        createMetaEventTitle(documentTitle)
      );
    }
  }, [title]);

  useEffect(() => {
    Tracker.pageviewEvent({ page_title: title });
  }, [title]);
};

export default usePageTitle;
